import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const validateAsOneLower =
    (): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null =>
        /[a-z]/.test(control.value)
            ? null
            : { validateAsOneLower: { valid: false } };

export const validateAsOneUpper =
    (): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null =>
        /[A-Z]/.test(control.value)
            ? null
            : { validateAsOneUpper: { valid: false } };

export const validateAsOneSpecial =
    (): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null =>
        /[`!@#$£%^&*()_+\-=\[\]{};':"\\|,.<>\/?~0123456789]/.test(control.value)
            ? null
            : { validateAsOneSpecial: { valid: false } };
